export enum SocketTopics {
  PRICES = "prices",
  GRAPHS_DATA = "graphs_data",
  PNL = "pnl",
  GLOBAL_PNL = "global_pnl",
  NOTIFICATIONS = "notifications",
  AGG_TRADES = "agg_trades",
  AGG_BOTS = "agg_bots",
}

export enum SocketOps {
  LOGIN = "login",
  SUBSCRIBE = "subscribe",
  UNSUBSCRIBE = "unsubscribe",
  PING = "ping",
}

export interface WebSocketResponse<T> {
  data: T;
  topic: SocketTopics;
  op: SocketOps;
  uuid?: string;
}
